var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M37 70.146C18.716 70.146 3.854 55.284 3.854 37S18.716 3.854 37 3.854c18.285 0 33.146 14.862 33.146 33.146S55.285 70.146 37 70.146Zm0-61.667C21.275 8.48 8.48 21.275 8.48 37c0 15.725 12.795 28.52 28.52 28.52S65.521 52.726 65.521 37 52.725 8.48 37.001 8.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M48.44 49.124a2.066 2.066 0 0 1-1.172-.34L37.71 43.08c-2.374-1.418-4.132-4.532-4.132-7.276V23.162a2.33 2.33 0 0 1 2.313-2.312 2.33 2.33 0 0 1 2.312 2.312v12.642c0 1.11.925 2.744 1.881 3.299l9.558 5.704c1.11.648 1.45 2.066.802 3.176a2.374 2.374 0 0 1-2.004 1.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.90a6bb1f1268c28b0ee6b01ca316644d.svg";
export { ForwardRef as ReactComponent };